/**
 * Given a program name, returns the theme color for the program.
 * @param {string} programName - The program's name.
 * @returns {string} The theme color slug.
 */
const getThemeColor = (programName) => {
  switch (programName) {
    case 'Arts':
      return 'red';
    case 'Communities':
      return 'green';
    case 'Journalism':
      return 'blue';
    case 'Technology':
      return 'yellow';
    case 'Learning and Impact':
      return 'yellow';
    default:
      return '';
  }
};

export default getThemeColor;
